export default {
    title: "403 FORBIDEN - ROBO INU FINANCE",
    mounted() {
        document.body.classList.add("body-error-page");
    },
    destroyed() {
        document.body.classList.remove("body-error-page");
    },
};
